import { render } from "./tabnav.vue?vue&type=template&id=4c4ae1ec&scoped=true"
import script from "./tabnav.vue?vue&type=script&lang=js"
export * from "./tabnav.vue?vue&type=script&lang=js"

import "./tabnav.vue?vue&type=style&index=0&id=4c4ae1ec&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\Desktop\\tapit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c4ae1ec"]])

export default __exports__